// extracted by mini-css-extract-plugin
export default {"Liststyle":"style_Liststyle__whr0K"};